import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { StoreBadge } from "@/components/StoreBadge";
import { gbp, imgSrc } from "@/lib/api";
import { Stars } from "@/components/Stars";

export const ProductCard = ({ p, index = 0 }) => {
  const { add } = useCart();
  return (
    <div
      className="rise group relative bg-white rounded-2xl border border-[#EDE4D3] overflow-hidden hover:shadow-[0_18px_40px_-18px_rgba(140,34,32,0.35)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
      style={{ animationDelay: `${index * 70}ms` }}
      data-testid={`product-card-${p.id}`}
    >
      <Link to={`/product/${p.id}`} className="block aspect-square bg-[#F7F3EB] p-6" data-testid={`product-link-${p.id}`}>
        <img src={imgSrc(p.image_url)} alt={p.name} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      </Link>
      <div className="absolute top-3 left-3"><StoreBadge store={p.store} /></div>
      {!p.in_stock && (
        <span className="absolute top-3 right-3 text-[10px] font-mono uppercase px-2.5 py-1 rounded-full bg-rose-100 text-rose-800" data-testid="out-of-stock-badge">
          Sold out
        </span>
      )}
      {p.in_stock && p.stock_qty != null && p.stock_qty <= 5 && (
        <span className="absolute top-3 right-3 text-[10px] font-mono uppercase px-2.5 py-1 rounded-full bg-amber-100 text-amber-800" data-testid="low-stock-badge">
          Only {p.stock_qty} left
        </span>
      )}
      <div className="p-5">
        <p className="text-[11px] font-mono uppercase tracking-widest text-[#8C2220]">{p.category}</p>
        <Link to={`/product/${p.id}`}>
          <h3 className="mt-1.5 font-semibold text-slate-900 leading-snug line-clamp-2 min-h-[2.75rem] hover:text-[#8C2220]">{p.name}</h3>
        </Link>
        {p.rating_count > 0 && <Stars value={p.rating_avg} count={p.rating_count} className="mt-1" />}
        <div className="mt-4 flex items-center justify-between">
          <div>
            <span className="font-serif text-2xl font-bold text-slate-900" data-testid={`product-price-${p.id}`}>{gbp(p.price)}</span>
            {p.weight && <span className="ml-2 text-xs text-slate-500">{p.weight}</span>}
          </div>
          <button
            disabled={!p.in_stock}
            onClick={() => add(p)}
            className="w-11 h-11 rounded-full bg-[#1B3626] text-white grid place-items-center hover:bg-[#8C2220] active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed transition-[background-color,transform]"
            data-testid={`add-to-cart-${p.id}`}
            aria-label="Add to basket"
          >
            <Plus className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
